import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object({
    newApprovalTypeId: Yup.string().required('Required').nullable(),
    newName: Yup.string().required('Required').nullable(),
    newPriorityNumber: Yup.string().required('Required').nullable(),
  });
